webpackJsonp([45],{

/***/ 1011:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_accounting_filter_vue__ = __webpack_require__(945);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ed2bbb2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_accounting_filter_vue__ = __webpack_require__(1014);
function injectStyle (ssrContext) {
  __webpack_require__(1012)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2ed2bbb2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_accounting_filter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ed2bbb2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_accounting_filter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1012:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1013);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(721)("70aca855", content, true, {});

/***/ }),

/***/ 1013:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(720)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:AvenirRegular;src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Regular.woff\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:AvenirBold;src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Bold.woff\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:AvenirDemi;src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Demi.woff\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_bold;src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_light;src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_regular;src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_bold;src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_semibold;src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_light;src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:400;font-style:normal}.full-width[data-v-2ed2bbb2]{width:100%}.filter-company[data-v-2ed2bbb2]{margin:0 30px 0 0}@media(max-width:768px){.filter-company[data-v-2ed2bbb2]{margin:0 0 30px}}", "", {"version":3,"sources":["/opt/build/repo/src/components/accounting-plans/accounting-filter.vue"],"names":[],"mappings":"AACA,WAAW,0BAA4B,6DAA6D,gBAAmB,kBAAkB,iBAAiB,CACzJ,AACD,WAAW,uBAAyB,0DAA0D,gBAAmB,kBAAkB,iBAAiB,CACnJ,AACD,WAAW,uBAAyB,0DAA0D,gBAAmB,kBAAkB,iBAAiB,CACnJ,AACD,WAAW,yBAA2B,0CAA0C,gBAAmB,iBAAiB,CACnH,AACD,WAAW,sBAAwB,uCAAuC,gBAAmB,iBAAiB,CAC7G,AACD,WAAW,uBAAyB,wCAAwC,gBAAmB,iBAAiB,CAC/G,AACD,WAAW,0BAA4B,8CAA8C,gBAAmB,iBAAiB,CACxH,AACD,WAAW,uBAAyB,2CAA2C,gBAAmB,iBAAiB,CAClH,AACD,WAAW,2BAA6B,+CAA+C,gBAAmB,iBAAiB,CAC1H,AACD,WAAW,wBAA0B,4CAA4C,gBAAmB,iBAAiB,CACpH,AACD,6BAA6B,UAAU,CACtC,AACD,iCAAiC,iBAAiB,CACjD,AACD,wBACA,iCAAiC,eAAiB,CACjD,CACA","file":"accounting-filter.vue","sourcesContent":["\n@font-face{font-family:\"AvenirRegular\";src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Regular.woff\");font-weight:normal;font-display:swap;font-style:normal\n}\n@font-face{font-family:\"AvenirBold\";src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Bold.woff\");font-weight:normal;font-display:swap;font-style:normal\n}\n@font-face{font-family:\"AvenirDemi\";src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Demi.woff\");font-weight:normal;font-display:swap;font-style:normal\n}\n@font-face{font-family:\"Lato_regular\";src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_bold\";src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_light\";src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_regular\";src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_bold\";src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_semibold\";src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_light\";src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:normal;font-style:normal\n}\n.full-width[data-v-2ed2bbb2]{width:100%\n}\n.filter-company[data-v-2ed2bbb2]{margin:0 30px 0 0\n}\n@media(max-width: 768px){\n.filter-company[data-v-2ed2bbb2]{margin:0 0 30px 0\n}\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1014:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('general-filter',{staticClass:"layout wrap",class:{ 'column px-0' : _vm.column, 'px-5 mt-4' : !_vm.column }},[(!_vm.hidenCompany)?_c('v-flex',{staticClass:"filter-company",class:{ 'sm3' : !_vm.column, 'full-width' : _vm.column },attrs:{"xs12":""}},[_c('BaseSelect',{attrs:{"autocomplete":"","return-object":"","item-text":"name","item-value":"id","label":"Empresa","height":33,"items":_vm.companies,"value":_vm.newSubsidiaryId},on:{"input":function($event){return _vm.setData($event, 'subsidiaryId')}}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{staticClass:"filter-company",class:{ 'sm3' : !_vm.column, 'full-width' : _vm.column },attrs:{"xs12":""}},[_c('BaseSelect',{attrs:{"solo":"","return-object":"","label":"Año","item-text":"year","item-value":"id","disabled":_vm.disabledYears,"height":33,"items":_vm.years,"value":_vm.newYearId},on:{"input":function($event){return _vm.setData($event, 'yearAccountantId')}}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1124:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_action_sidebar__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_accounting_plans_acc_plan_active_form__ = __webpack_require__(1303);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




function created() {
	if (this.subsidiaryId) {
		this.params.subsidiaryId = this.subsidiaryId;
	}
	if (this.yearAccountantId) {
		this.params.yearAccountantId = this.yearAccountantId;
	}
}

function closeModal() {
	this.goTo('accounting-plans', { params: { subsidiaryId: this.params.subsidiaryId } });
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'page-accounting-plan-active',
	components: {
		actionSidebar: __WEBPACK_IMPORTED_MODULE_0__components_shared_action_sidebar__["a" /* default */],
		accPlanActiveForm: __WEBPACK_IMPORTED_MODULE_1__components_accounting_plans_acc_plan_active_form__["a" /* default */]
	},
	created: created,
	methods: {
		closeModal: closeModal
	},
	props: {
		subsidiaryId: [Number, String],
		yearAccountantId: [Number, String]
	}
});

/***/ }),

/***/ 1125:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_accounting_plans_accounting_filter__ = __webpack_require__(1011);



var loadPlans = function () {
	var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
		var params, _ref3;

		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						params = {
							subsidiaryId: this.params.subsidiaryId,
							yearAccountantId: this.params.yearAccountantId
						};
						_context.next = 3;
						return this.$http.get('com-accounting-plan', { params: params });

					case 3:
						_ref3 = _context.sent;
						this.plans = _ref3.data;

					case 5:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function loadPlans() {
		return _ref2.apply(this, arguments);
	};
}();

var loadSubsidiaries = function () {
	var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
		var dataUserInfo, params, _ref5;

		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						dataUserInfo = typeof this.$userInfo === 'string' ? JSON.parse(this.$userInfo) : this.$userInfo;
						params = {
							customerId: dataUserInfo ? dataUserInfo.subsidiary.customerId : null
						};
						_context2.next = 4;
						return this.$http.get('subsidiary', { params: params });

					case 4:
						_ref5 = _context2.sent;
						this.subsidiaries = _ref5.data;

						if (this.subsidiaryId) {
							this.params.subsidiaryId = this.subsidiaryId;
							this.loadYears(this.subsidiaryId);
						}

					case 7:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this);
	}));

	return function loadSubsidiaries() {
		return _ref4.apply(this, arguments);
	};
}();

var loadYears = function () {
	var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(id) {
		var params, _ref7;

		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						params = { subsidiaryId: id };
						_context3.next = 3;
						return this.$http.get('com-year-accountant', { params: params });

					case 3:
						_ref7 = _context3.sent;
						this.yearsBySubsidiary = _ref7.data;

						if (this.yearAccountantId) {
							this.params.yearAccountantId = this.yearAccountantId;
							this.loadPlans();
						}

					case 6:
					case 'end':
						return _context3.stop();
				}
			}
		}, _callee3, this);
	}));

	return function loadYears(_x) {
		return _ref6.apply(this, arguments);
	};
}();

var submitForm = function () {
	var _ref8 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
			while (1) {
				switch (_context4.prev = _context4.next) {
					case 0:
						this.loading = true;
						_context4.prev = 1;
						_context4.next = 4;
						return this.$http.patch('com-accounting-plan/' + this.planId + '/active');

					case 4:
						this.showNotification('El plan ha sido activado correctamente.');
						this.closeModal();
						_context4.next = 11;
						break;

					case 8:
						_context4.prev = 8;
						_context4.t0 = _context4['catch'](1);

						if (_context4.t0.status === 500) {
							this.showGenericError();
						}

					case 11:
						_context4.prev = 11;

						this.loading = false;
						return _context4.finish(11);

					case 14:
					case 'end':
						return _context4.stop();
				}
			}
		}, _callee4, this, [[1, 8, 11, 14]]);
	}));

	return function submitForm() {
		return _ref8.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var PAGE_ACCOUNTING_PLAN_LIST = 'accounting-plans';

function created() {
	this.loadSubsidiaries();
}

function closeModal() {
	this.goTo(PAGE_ACCOUNTING_PLAN_LIST, { params: { subsidiaryId: this.params.subsidiaryId } });
}

function disabled() {
	return !this.planId || this.loading;
}

function filter(_ref) {
	var value = _ref.value,
	    model = _ref.model;

	this.params[model] = value.id;
	this.planId = null;
	if (model === 'subsidiaryId') {
		this.params.yearAccountantId = null;
		this.loadYears(this.params.subsidiaryId);
	} else if (model === 'yearAccountantId') {
		this.loadPlans();
	}
}

function setPlan(value, model) {
	this[model] = value;
}

function data() {
	return {
		loading: false,
		planId: null,
		plans: [],
		subsidiaries: [],
		yearsBySubsidiary: []
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'acc-plan-active-form',
	components: {
		accountingFilter: __WEBPACK_IMPORTED_MODULE_2__components_accounting_plans_accounting_filter__["a" /* default */],
		BaseSelect: function BaseSelect() {
			return __webpack_require__.e/* import() */(50/* duplicate */).then(__webpack_require__.bind(null, 766));
		}
	},
	computed: {
		disabled: disabled
	},
	created: created,
	data: data,
	methods: {
		closeModal: closeModal,
		filter: filter,
		loadPlans: loadPlans,
		loadSubsidiaries: loadSubsidiaries,
		loadYears: loadYears,
		setPlan: setPlan,
		submitForm: submitForm
	},
	props: {
		subsidiaryId: [Number, String],
		yearAccountantId: [Number, String]
	}
});

/***/ }),

/***/ 1303:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_acc_plan_active_form_vue__ = __webpack_require__(1125);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ac815c8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_acc_plan_active_form_vue__ = __webpack_require__(1304);
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_acc_plan_active_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ac815c8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_acc_plan_active_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1304:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form-sidebar',[_c('v-form',[_c('accounting-filter',{attrs:{"column":"","companies":_vm.subsidiaries,"subsidiary-id":_vm.params.subsidiaryId,"disabled-years":!_vm.params.subsidiaryId,"year-accountant-id":_vm.params.yearAccountantId,"years":_vm.yearsBySubsidiary},on:{"filter":function($event){return _vm.filter($event)}}}),_vm._v(" "),_c('v-layout',{attrs:{"wrap":"","mt-2":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('BaseSelect',{attrs:{"disabled":!_vm.params.yearAccountantId,"height":38,"item-text":"description","item-value":"id","items":_vm.plans,"return-object":false,"label":"Plan de Cuentas"},on:{"input":function($event){return _vm.setPlan($event, 'planId')}},model:{value:(_vm.planId),callback:function ($$v) {_vm.planId=$$v},expression:"planId"}})],1)],1),_vm._v(" "),_c('section',{staticClass:"modal-filter-footer"},[_c('modal-sidebar-button',{attrs:{"is-loading":_vm.disabled},on:{"cancel-button-clicked":_vm.closeModal,"accept-button-clicked":_vm.submitForm}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1305:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('action-sidebar',{attrs:{"title":"Activar Plan de Cuentas","value":true},on:{"close-modal":_vm.closeModal}},[_c('acc-plan-active-form',{attrs:{"subsidiary-id":_vm.params.subsidiaryId,"year-accountant-id":_vm.params.yearAccountantId}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 728:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_accounting_plan_active_vue__ = __webpack_require__(1124);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54e97485_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_accounting_plan_active_vue__ = __webpack_require__(1305);
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_accounting_plan_active_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54e97485_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_accounting_plan_active_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 945:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function setData(val, model) {
	this.$emit('filter', { value: val, model: model });
}

function newSubsidiaryId() {
	return this.subsidiaryId;
}

function newYearId() {
	return this.yearAccountantId;
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'accounting-filter',
	components: {
		BaseSelect: function BaseSelect() {
			return __webpack_require__.e/* import() */(50/* duplicate */).then(__webpack_require__.bind(null, 766));
		}
	},
	computed: {
		newSubsidiaryId: newSubsidiaryId,
		newYearId: newYearId
	},
	methods: {
		setData: setData
	},
	props: {
		column: {
			default: false,
			type: Boolean
		},
		companies: {
			default: function _default() {
				return [];
			},
			type: Array
		},
		disabledYears: {
			default: false,
			type: Boolean
		},
		subsidiaryId: [Number, String],
		yearAccountantId: [Number, String],
		years: {
			default: function _default() {
				return [];
			},
			type: Array
		},
		hidenCompany: {
			default: false,
			type: Boolean
		}
	}
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/45.94cdfe2805e18391de87.js